import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionPlanService } from 'src/app/core/services/action-plan.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { AppealService } from 'src/app/core/services/appeal.service';

@Component({
  selector: 'app-appeal',
  templateUrl: './appeal.component.html',
  styleUrls: ['./appeal.component.css']
})
export class AppealComponent implements OnInit {

   isArabic!: boolean;
    @Input() appealList: any;
    userData: any;
    appealCount: any;
    appealHistorical?: boolean;
  
     constructor(private route: Router, private storageService: StorageService,
        private actionPlanService: ActionPlanService, private commonService: CommonService, private appealService: AppealService
      ) { }
  
    ngOnInit(): void {
      this.isArabic = this.storageService.getSessionStorageData('isArabic');
      this.userData = this.storageService.getSessionStorageData('userDetails');
      this.appealHistorical = this.storageService.getSessionStorageData('appealHistorical');

      if (this.appealList && this.appealList.length > 0) {
        const currentUrl = this.route.url; // full current URL

        this.appealList.forEach((item: { isActive: boolean; link: string; }) => {
          // mark active if current URL includes the item's link
          if(this.appealHistorical && currentUrl.includes("appeal/detail")) {
            this.appealList[1].isActive = true;
          }else{
            item.isActive = currentUrl.includes(item.link);
          }
        });

        // Optional fallback: if no match, activate first item
        if (!this.appealList.some((item: { isActive: any; }) => item.isActive)) {
          this.appealList[0].isActive = true;
        }
      }

      this.appealService.appealCount$.subscribe(count => {
        if(count){
          this.appealCount = count;
        }else{
          this.appealCount = this.storageService.getSessionStorageData('appealCount');;
        }
      });
    }
     onListItemClick(selectedItemIdx: number) {
      this.appealList.forEach((v: any, i: any) => {
        if (i === selectedItemIdx) {
          v.isActive = true;
        } else {
          v.isActive = false;
        }
      });
       if (this.appealList[selectedItemIdx].link !== '') {
        let path = 'executor-dashboard/' + this.appealList[selectedItemIdx].link;
        this.route.navigate([path]);
      }
    }
  
  }
